import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext'

// Layouts
import MainLayout   from './components/layout/MainLayout'
import AdminLayout  from './components/layout/AdminLayout'
import AuthLayout   from './components/layout/AuthLayout'

// Public pages
import Home         from './pages/Home'
import Services     from './pages/Services'
import ServiceDetail from './pages/ServiceDetail'
import About        from './pages/About'
import Contact      from './pages/Contact'
import Gallery      from './pages/Gallery'
import Staff        from './pages/Staff'

// Marketing pages
import Pricing  from './pages/marketing/Pricing'
import FAQ      from './pages/marketing/FAQ'
import Privacy  from './pages/marketing/Privacy'
import Terms    from './pages/marketing/Terms'
import Careers  from './pages/marketing/Careers'
import Blog     from './pages/marketing/Blog'
import BlogPost from './pages/marketing/BlogPost'
import NotFound from './pages/marketing/NotFound'

// Booking
import BookingPage  from './pages/booking/BookingPage'
import BookingConfirmation from './pages/booking/BookingConfirmation'

// Auth
import Login        from './pages/auth/Login'
import Register     from './pages/auth/Register'
import ForgotPassword from './pages/auth/ForgotPassword'
import ResetPassword  from './pages/auth/ResetPassword'

// Customer Dashboard
import CustomerDashboard from './pages/customer/Dashboard'
import MyAppointments    from './pages/customer/MyAppointments'
import MyProfile         from './pages/customer/Profile'

// Admin
import AdminDashboard     from './pages/admin/Dashboard'
import ManageAppointments from './pages/admin/ManageAppointments'
import ManageStaff        from './pages/admin/ManageStaff'
import ManageServices     from './pages/admin/ManageServices'
import ManageCustomers    from './pages/admin/ManageCustomers'
import ManageCoupons      from './pages/admin/ManageCoupons'
import AdminReports       from './pages/admin/Reports'
import AdminSettings      from './pages/admin/Settings'

// Guards
function PrivateRoute({ children, role }) {
  const { user, loading } = useAuth()
  if (loading) return <div className="flex h-screen items-center justify-center"><div className="w-10 h-10 border-4 border-salon-primary border-t-transparent rounded-full animate-spin" /></div>
  if (!user) return <Navigate to="/login" replace />
  if (role && user.role !== role && user.role !== 'admin') return <Navigate to="/" replace />
  return children
}

export default function App() {
  return (
    <Routes>
      {/* ── Public Routes ── */}
      <Route element={<MainLayout />}>
        <Route path="/"               element={<Home />} />
        <Route path="/services"       element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/pricing"        element={<Pricing />} />
        <Route path="/about"          element={<About />} />
        <Route path="/contact"        element={<Contact />} />
        <Route path="/gallery"        element={<Gallery />} />
        <Route path="/our-team"       element={<Staff />} />
        <Route path="/faq"            element={<FAQ />} />
        <Route path="/blog"           element={<Blog />} />
        <Route path="/blog/:slug"     element={<BlogPost />} />
        <Route path="/careers"        element={<Careers />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/terms"          element={<Terms />} />
        <Route path="/book"           element={<BookingPage />} />
        <Route path="/booking/confirmation/:id" element={<BookingConfirmation />} />
      </Route>

      {/* ── Auth Routes ── */}
      <Route element={<AuthLayout />}>
        <Route path="/login"           element={<Login />} />
        <Route path="/register"        element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password"  element={<ResetPassword />} />
      </Route>

      {/* ── Customer Dashboard ── */}
      <Route path="/dashboard" element={<PrivateRoute><MainLayout /></PrivateRoute>}>
        <Route index                  element={<CustomerDashboard />} />
        <Route path="appointments"    element={<MyAppointments />} />
        <Route path="profile"         element={<MyProfile />} />
      </Route>

      {/* ── Admin Routes ── */}
      <Route path="/admin" element={<PrivateRoute role="admin"><AdminLayout /></PrivateRoute>}>
        <Route index                   element={<AdminDashboard />} />
        <Route path="appointments"     element={<ManageAppointments />} />
        <Route path="staff"            element={<ManageStaff />} />
        <Route path="services"         element={<ManageServices />} />
        <Route path="customers"        element={<ManageCustomers />} />
        <Route path="coupons"          element={<ManageCoupons />} />
        <Route path="reports"          element={<AdminReports />} />
        <Route path="settings"         element={<AdminSettings />} />
      </Route>

      {/* ── Fallback ── */}
      <Route element={<MainLayout />}>
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
